
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(8(0|69|71)|41|540|590|772|943)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
